/**
 * 枚举
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 枚举
 */
export class GSPEnumValue {

    /**
     * 值
     */
    public Value: string;

    /**
     * 名称
     */
    public Name: string;

    /**
     * 索引
     */
    public Index: number;

    /**
     * 字符串索引
     */
    public StringIndex: string;

    /**
     * 是否默认值
     */
    public IsDefaultEnum: boolean;
    /**
     * 枚举项禁用
     */
    public EnumItemDisabled: boolean;
}
